import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CurrentUserService } from './current-user.service';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private _currentUserService: CurrentUserService,
    private headerHelperService: HeaderHelperService
  ) {}

  login(email: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http
      .post<any>(
        `${environment.apiLocations.identity}/Auth`,
        { email, password },
        { headers: headers }
      )
      .pipe(
        map((user) => {
          // if (user && user.token) {
          //   this._currentUserService.SetSession(user);
          // }
          return user;
        })
      );
  }
}
